import script from "./H5Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./H5Header.vue?vue&type=script&setup=true&lang=ts"

import "./H5Header.vue?vue&type=style&index=0&id=573b5de2&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573b5de2"]])

export default __exports__